import React from 'react';
import PropTypes from 'prop-types';
import { Img } from 'react-image';
import styled, { keyframes } from 'styled-components';

export const r = 551 / 565;
export const wDesktop = 551;
// 82vw is the maximium width we can keep all of the tiles inside the boundary
export const wMobile = 82;
const rMD = wMobile / wDesktop;

const BaseImage = styled(Img)`
  position: absolute;
  box-shadow: 0px 3px 20px ${props => props.theme.secondaryColorLight};
  border-radius: 20px;
  background-color: white;
  transform: translate(0px, 0px);
`;

const Image = styled(BaseImage)`
  cursor: pointer;
  z-index: 2;
  width: ${props => (props.theme.isMobile ? `${107 * rMD}vw` : '107px')};
`;

const ActiveImage = styled(BaseImage)`
  cursor: initial;
  z-index: 1;
  width: ${props => (props.theme.isMobile ? `${211 * rMD}vw` : '211px')};
`;

const rand = range => (Math.random() * 2 * range - range);

export default function CompanyTestimonial(props) {
  const {
    img, offset, isCurrent, onClick,
  } = props;

  const float = keyframes`
    0% {
      transform: translate(0px, 0px);
    }
    50% {
      transform: translate(${rand(15)}px, ${rand(15)}px);
    }
    100% {
      transform: translate(0px, 0px);
    }
  `;

  const bound = {
    top: offset.top - (isCurrent ? 52 : 0),
    left: offset.left - (isCurrent ? 52 : 0),
  };
  const AnimatedImage = styled(isCurrent ? ActiveImage : Image)`
    animation: ${float} 10s ease-in-out infinite;
    top: ${p => (p.theme.isMobile ? `${bound.top * rMD}vw` : `${bound.top}px`)};
    margin-left: ${p => (p.theme.isMobile ? `${bound.left * rMD}vw` : `${bound.left}px`)};
  `;

  const propData = {
    src: img,
    ...(isCurrent ? {} : { onClick }),
  };
  return <AnimatedImage {...propData} />;
}

CompanyTestimonial.propTypes = {
  img: PropTypes.string.isRequired,
  offset: PropTypes.shape({
    top: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
  }).isRequired,
  isCurrent: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
